import React from 'react';
import { cn } from '../../lib/utils';

/**
 * Standard page header used across the product.
 * title → description → optional actions (right)
 */
export default function PageHeader({
  title,
  description,
  actions,
  className,
  children,
}) {
  return (
    <div className={cn('flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between', className)}>
      <div className="min-w-0 space-y-1">
        <h1 className="oc-page-title">{title}</h1>
        {description ? <p className="oc-page-desc max-w-2xl">{description}</p> : null}
        {children}
      </div>
      {actions ? (
        <div className="flex flex-shrink-0 flex-wrap items-center gap-2">{actions}</div>
      ) : null}
    </div>
  );
}
